import React, {useState} from "react";
import Layout from "../hocs/Layout";
import {connect} from "react-redux";
import Part1 from "../components/carrito/part1";
import Part3 from "../components/carrito/part3";
import Part4 from "../components/carrito/part4";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCartShopping, faUser, faClipboardCheck, faCheck} from "@fortawesome/free-solid-svg-icons";

const steps = [
    {id: 1, label: "Carrito", icon: faCartShopping},
    {id: 2, label: "Datos", icon: faUser},
    {id: 3, label: "Confirmación", icon: faClipboardCheck},
];

const Carrito = () => {
    const [position, SetPosition] = useState(1);

    const updatePosition = (val) => {
        SetPosition(val);
    }

    return (
        <Layout>
            {/* Stepper */}
            <div className="w-full bg-white border-b">
                <div className="container mx-auto px-4 py-4 md:py-6">
                    <div className="flex items-center justify-center max-w-xl mx-auto">
                        {steps.map((step, index) => (
                            <React.Fragment key={step.id}>
                                {/* Step Circle + Label */}
                                <div className="flex flex-col items-center relative">
                                    <div
                                        className={`
                                            w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center
                                            text-sm md:text-base font-bold transition-all duration-300
                                            ${position > step.id
                                                ? 'bg-green-500 text-white shadow-lg shadow-green-200'
                                                : position === step.id
                                                    ? 'bg-ecoprimary1 text-white shadow-lg shadow-blue-200 ring-4 ring-blue-100'
                                                    : 'bg-gray-100 text-gray-400'
                                            }
                                        `}
                                    >
                                        {position > step.id
                                            ? <FontAwesomeIcon icon={faCheck} className="text-sm md:text-base"/>
                                            : <FontAwesomeIcon icon={step.icon} className="text-sm md:text-base"/>
                                        }
                                    </div>
                                    <span
                                        className={`
                                            mt-2 text-xs md:text-sm font-semibold whitespace-nowrap transition-colors duration-300
                                            ${position >= step.id ? 'text-ecoprimary1' : 'text-gray-400'}
                                        `}
                                    >
                                        {step.label}
                                    </span>
                                </div>
                                {/* Connector Line */}
                                {index < steps.length - 1 && (
                                    <div className="flex-1 mx-2 md:mx-4 mb-6">
                                        <div className="h-1 rounded-full overflow-hidden bg-gray-200">
                                            <div
                                                className={`h-full rounded-full transition-all duration-500 ease-out ${
                                                    position > step.id ? 'w-full bg-green-500' : 'w-0 bg-ecoprimary1'
                                                }`}
                                            />
                                        </div>
                                    </div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>

            {position === 1 &&
                <Part1 next={updatePosition}/>
            }
            {position === 2 &&
                <Part3 next={updatePosition}/>
            }
            {position === 3 &&
                <Part4 next={updatePosition}/>
            }
        </Layout>
    );
};


const mapStateToProps = state => ({})

export default connect(mapStateToProps, {})(Carrito)
